import React from 'react';
import PropTypes from 'prop-types';
import { historyShape } from 'constants/propTypes';
import querystring from 'querystring';
import BookingStandardSearchResults from './BookingStandardSearchResults';
import BookingOnHoldSearchResults from './BookingOnHoldSearchResults';
import BookingsWithMinorsSearchResults from './BookingsWithMinorsSearchResults';
import BookingAssistanceSearchResults from './BookingAssistanceSearchResults.js';
import BookingsWithLuggageSearchResults from './BookingsWithLuggageSearchResults';

const BookingSearchResults = (props) => {
  const {
    history: {
      location: { search }
    }
  } = props;
  const { expiry, period, detailKey, detailValue, travelDate, stationUIC } = querystring.parse(search.substr(1));

  if (detailKey && detailValue) {
    return <BookingAssistanceSearchResults detailKey={detailKey} detailValue={detailValue} />;
  }

  if (travelDate && stationUIC) {
    return <BookingsWithLuggageSearchResults {...props} />;
  }

  return expiry ? (
    <BookingOnHoldSearchResults {...props} />
  ) : period ? (
    <BookingsWithMinorsSearchResults {...props} />
  ) : (
    <BookingStandardSearchResults {...props} />
  );
};

BookingSearchResults.propTypes = {
  history: historyShape,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func
  })
};

export default BookingSearchResults;
